import { IElementsVisibilityState, EElementsVisibilitySummaryView } from '../../types/reducers/elementsVisibility';

export const defaultState: IElementsVisibilityState = {
  publicationWrapper: {
    isVisibleWithoutPackages: true,
  },
  promotionWrapper: {
    isMoneySourceWidgetVisible: false,
  },
  summary: {
    view: EElementsVisibilitySummaryView.TwoColumns,
    isMoneySourceWidgetVisible: true,
  },
};
